import { Jaquette, SeeMore } from '../types';

export function isJaquette(jaquette: Jaquette | SeeMore): jaquette is Jaquette {
  return (jaquette as Jaquette).type === 'media';
}
